import router from '@/router'

export default {
  state: {
    section: [],
    detailedSection: []
  },
  mutations: {
    setSection (state, payload) {
      state.section = payload
    },
    setDetailedSection (state, payload) {
      state.detailedSection = payload
    }
  },
  actions: {
    async setSection (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/admin/section`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      res = await res.json()
      this.commit('setSection', await res)
    },

    async setDetailedSection (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/admin/section/${payload}`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      res = await res.json()
      this.commit('setDetailedSection', await res)
    },

    async deleteSection (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/section/${payload}`, {
        method: 'DELETE',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }).then(res => {
        if (res.status === 200) {
          ctx.commit('setMessage', {
            type: 'success',
            text: 'Секция успешно удалена'
          })
        } else {
          ctx.commit('setMessage', { type: 'error', text: 'Ошибка удаления' })
        }
        ctx.dispatch('setSection')
      })
        .catch(error => console.log('error', error))
    },

    async createSection (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/section`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token')
        },
        body: payload
      })
        .then(res => {
          if (res.status === 201) {
            router.push('/admin/section')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Создание секции прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка создания'
            })
          }
        })
        .catch(error => console.log('error', error))
    },

    async editSection (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/section/${payload.id}`, {
        method: 'POST',
        body: payload.data
      })
        .then(res => {
          if (res.status === 200) {
            router.push('/admin/section')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Изменение секции прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка изменения'
            })
          }
        })
        .catch(error => console.log('error', error))
    }
  },
  getters: {
    getAdminSection: (s) => s.section,
    getDetailedSection: (s) => s.detailedSection
  }
}
